import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function BuildWebsite() {
  return <ServiceDetailPage service={servicePageContent.buildWebsites} />;
}
